// extracted by mini-css-extract-plugin
module.exports = {"cls1":"Headlines-BigH1-module--cls1--321JZ","cls2":"Headlines-BigH1-module--cls2--29uqJ Headlines-BigH1-module--cls1--321JZ"};